<div class="page-container">
  <div class="campanha">
    <div
      class="alert"
      [ngClass]="
        'btn-action-' +
        securityService.currentUserValue.empresa?.cor_lowercase.toLowerCase()
      "
    >
      <div class="d-flex text-white justify-content-between align-items-center">
        <div>Você está no modo campanha...</div>
        <div>
          <a class="text-white font-weight-bold" [routerLink]="['']"> SAIR </a>
        </div>
      </div>
    </div>
  </div>

  <div
    class="campanha"
    *ngIf="
      ativacoesService.ativacaoAtual &&
      ativacoesService.clienteAtivacaoAtual &&
      canShow
    "
  >
    <app-ativacao-actions
      [cliente]="ativacoesService.clienteAtivacaoAtual"
      [ativacao]="ativacoesService.ativacaoAtual"
      [currentVendedorInfo]="this.vendedorInfo"
      [modoCampanha]="true"
    ></app-ativacao-actions>
  </div>

  <div
    *ngIf="
      !ativacoesService.ativacaoAtual || !ativacoesService.clienteAtivacaoAtual
    "
    class="loading-box"
  >
    <mat-spinner></mat-spinner>

    <div class="text">Aguarde um momento...</div>
  </div>
</div>
